// extracted by mini-css-extract-plugin
export default {"fs":"b73bf13e18 e19a1f6a6c"};